export default class RecordsUtil
{
	static getOneLevelDatas(formDataSourceGroupResult,groupAlias)
	{
		  let dataResult = formDataSourceGroupResult.dataResult;
      let isArray = Array.isArray(dataResult);
  		let finalDatas = [];
      let proKey;
      var now = new Date().getTime();
      if(isArray)
      {
        for(let i in formDataSourceGroupResult.dataResult)
        {
          let finalData = {};
          let item = formDataSourceGroupResult.dataResult[i];
          //console.log(typeof(item));
          if(formDataSourceGroupResult.aliasList.length>1)
          {
            
            for(let k in item)
            {
              let innerItem = item[k];
              for(let key in innerItem)
              {
                proKey = formDataSourceGroupResult.aliasList[k]+"."+key;
                finalData[proKey] = innerItem[key];
              }
            }  
          }
          else
          {
            for(let key in item)
            {
              proKey = groupAlias+"."+key;
              finalData[proKey] = item[key];
            }
          }

          finalDatas.push(finalData);
        }
      }
      else
      {
        let finalData = {};
        if(formDataSourceGroupResult.aliasList.length>1)
        {
          for(let key in dataResult)
          {

          }
        }
        else
        {
          for(let key in dataResult)
          {
            finalData[groupAlias+"."+key] = dataResult[key];
          }  
        }
        
        finalDatas.push(finalData);
      }
  		
  		return finalDatas;
	}

  static getSecondaryRecord1(record,groupAlias,fieldName,componentItemName,newValue)
  {
    if(record == null)
      return null;
    var secondaryRecord = {remoteClass:"java.util.HashMap"};
    for(var key in record)
    {
      let value = record[key];
      let arr = key.split(".");
      if(arr.length == 1)
      {
        secondaryRecord[arr[0]] = value;
      }
      else if(arr.length == 2)
      {
        if(arr[0] == groupAlias)
        {
          if(arr[1] == fieldName)value = newValue;
          secondaryRecord[arr[1]] = value;
        }
          
      }
      else if(arr.length == 3)
      {
        if(arr[0] == groupAlias)
        {
          if(!secondaryRecord.hasOwnProperty(arr[1]))
            secondaryRecord[arr[1]] = {remoteClass:"java.util.HashMap"};
          if(arr[1] == fieldName && arr[2] == componentItemName)value = newValue;
          secondaryRecord[arr[1]][arr[2]] = value;
        }
      }
      else if(arr.length>3)//插件内部节点带点 如果包含.号 如果大于3个点 则认为是带点号字段
      {
        let arr0str = arr[0];
        if(arr0str == groupAlias)
        {
          let firstDotIndex = key.indexOf(".");
          let arr1str = key.substr(firstDotIndex+1);
          if(secondaryRecord[arr1str] && secondaryRecord[arr1str].remoteClass == "java.util.HashMap" && typeof(value) == "object")
            continue;
          secondaryRecord[arr1str] = value;
        }
      }
    }
    return secondaryRecord;
  }

  static getSecondaryRecord(record,groupAlias)
  {
    if(record == null)
      return null;
    let origGroupAlias = "";
    if(groupAlias && groupAlias.indexOf(".") != -1)
    {
      let groupAliasArr = groupAlias.split(".");
      origGroupAlias = groupAliasArr[groupAliasArr.length-1];
    }
    var secondaryRecord = {remoteClass:"java.util.HashMap"};
    for(var key in record)
    {
      let value = record[key];
      let arr = key.split(".");
      if(origGroupAlias)
      {
        let groupAliasIndex = arr.indexOf(origGroupAlias);
        arr = arr.slice(groupAliasIndex);
      }
     
      if(arr.length == 1)
      {
        secondaryRecord[arr[0]] = value;
      }
      else if(arr.length == 2)
      {
        if(arr[0] == groupAlias || arr[0] == origGroupAlias)
        {
          if(secondaryRecord[arr[1]] && secondaryRecord[arr[1]].remoteClass == "java.util.HashMap" && typeof(value) == "object")
            continue;
          secondaryRecord[arr[1]] = value;
        }
      }
      else if(arr.length == 3)//插件内部节点带点 如果包含.号 有3个点 认为是维度
      {
        if(arr[0] == groupAlias || arr[0] == origGroupAlias)
        {
          if(!secondaryRecord.hasOwnProperty(arr[1]))
            secondaryRecord[arr[1]] = {remoteClass:"java.util.HashMap"};
          secondaryRecord[arr[1]][arr[2]] = value;
        }
      }
      else if(arr.length>3)//插件内部节点带点 如果包含.号 如果大于3个点 则认为是带点号字段
      {
        let arr0str = arr[0];
        if(arr0str == groupAlias || arr0str == origGroupAlias)
        {
          let firstDotIndex = key.indexOf(".");
          let arr1str = key.substr(firstDotIndex+1);
          if(secondaryRecord[arr1str] && secondaryRecord[arr1str].remoteClass == "java.util.HashMap" && typeof(value) == "object")
            continue;
          secondaryRecord[arr1str] = value;
        }
      }
    }
    return secondaryRecord;
  }

  //(..DataSource.fileName=a*
  static analysisValue(value,fv,isNumber = false,isRightContext = false)
  {
    //if(isRightContext == true)
    //  return value == fv;
    var start1 = fv.charAt(0);
    var start2 = fv.substr(0,2);
    var end1 = fv.charAt(fv.length-1);
    var tempv;
    if(start1 == "#")
    {
      if(isNumber)return false;
      if(fv.substr(0,4).toLowerCase() == "#in(")
      {
        if(end1 != ")")
          tempv = fv.substring(4);
        else
          tempv = fv.substring(4,fv.length - 1);
          return value == tempv;
      }
      else if(fv.substr(0,5).toLowerCase()=="#not(" && end1 == ")")
      {
        tempv = fv.substring(5,fv.length-1);
        return value != tempv;
      }
      else if(fv.substr(0,7).toLowerCase()=="#null()" || fv.substr(0,5).toLowerCase() == "#null")
      {
        return (value == null || value == "");
      }
      else if(fv.substr(0,10).toLowerCase() == "#notnull()" || fv.substr(0,8).toLowerCase() == "#notnull")
      {
        return !(value == null || value == "");
      }
      else if(fv.substr(0,9).toLowerCase() == "#between:")
      {
        tempv = fv.substr(9);
        if(tempv.indexOf("|") == -1)
          return false;
        var tempa = tempv.split("|");
        return RecordsUtil.anaysisBetween(value,tempa[1],tempa[0]);
      }
      else if(fv.substr(0,12).toLowerCase() == "#notbetween:")
      {
        tempv = fv.substr(12);
        if(tempv.indexOf("|") == -1)
          return false;
        tempa = tempv.split("|");
        return !RecordsUtil.anaysisBetween(value,tempa[1],tempa[0]);
      }
      else if(fv.substr(0,6).toLowerCase() == "#like:")
      {
        tempv = fv.substr(6);
        
        return RecordsUtil.anaysisLike(value,tempv);
      }
      else if(fv.substr(0,9).toLowerCase() == "#notlike:")
      {
        tempv = fv.substr(9);
        
        return !RecordsUtil.anaysisLike(value,tempv);
      }
    }
    else if(start2 == "!=" || start2 == "<>")
    {
      tempv = fv.substr(2);
      if(isNumber)
      {
        var numvalue = parseFloat(value);
        var numtempv = parseFloat(tempv);
        if(isNaN(numvalue) || isNaN(numtempv))return true;
        return numvalue != numtempv;
      }
      else
      {
        return value != tempv;
      }
    }
    else if(start2 == "!(" && end1 == ")")
    {
      tempv = fv.substring(2,fv.length-1);
      if(fv.indexOf("..") == -1)
      {
        if(isNumber)
        {
          numvalue = parseFloat(value);
          numtempv = parseFloat(tempv);
          if(isNaN(numvalue) || isNaN(numtempv))return true;
          return numvalue != numtempv;
        }
        else
        {
          return value!=tempv;
        }
      }
      else
      {
        tempa = tempv.split("..");
        return !RecordsUtil.anaysisBetween(value,tempa[1],tempa[0]);
      }
    }
    else if(start2 == "<=")
    {
      tempv = fv.substr(2);
      return (value == tempv || RecordsUtil.analysisLess(value,tempv));
    }
    else if(start2 == ">=")
    {
      tempv = fv.substr(2);
      return (value == tempv || RecordsUtil.anaysisMore(value,tempv));
    }
    else if(start1 == "<")
    {
      tempv = fv.substr(1);
      return RecordsUtil.analysisLess(value,tempv);
    }
    else if(start1 == ">")
    {
      tempv = fv.substr(1);
      return RecordsUtil.anaysisMore(value,tempv);
    }
    else if(fv.indexOf("..") != -1)
    {
      tempa = fv.split("..");
      return RecordsUtil.anaysisBetween(value,tempa[1],tempa[0]);
    }
    else if(fv.indexOf("*") != -1 || fv.indexOf("?") != -1)
    {
      return RecordsUtil.anaysisLike(value,fv);
    }
    else
    {
      if((value == "true" || value == "1") &&( fv == "true" || fv == "1" ))
        return true;
      if((value == "false" || value == "0") && (fv == "false" || fv == "0"))
        return true;
      // if(end1 == ")")
      //   fv = fv.substring(0,fv.length-1);
      return RecordsUtil.analysisEQ(fv,value); 
    }
    
    return false;
  }

  static analysisEQ(exp,value)
  {
    if(exp=="''")
      return value==null||value=="";
    if(typeof(value) == "number")
      return value == parseFloat(exp);
    return value==exp;
  }

  static anaysisBetween(value,vMax,vMin,isNumber = false)
  {
    return ((value == vMax) || (value == vMin)) || (RecordsUtil.analysisLess(value,vMax) && RecordsUtil.anaysisMore(value,vMin));
  }

  static anaysisLike(value,v)
  {
    if(v.indexOf("*") != -1)
    {
      let first = v.charAt(0);
      let end = v.charAt(v.length-1);
      let end2;
      if(v.length>=2){
        end2 = v.charAt(v.length-2);
      }
      if(first=='*' && end=='*'){
        var s = "[\\s\\S]*";
        var reg = /\*/g;
        v = v.replace(reg,s);
        var result = value.match(new RegExp(v,"i"));
        return result==null?false:result.length>0;
      }else{
        if(end2=='*' && end=='*'){
          var s = "[\\s\\S]*";
          var reg = /\*/g;
          v = v.replace(reg,s);
          var result = value.match(new RegExp(v,"i"));
          return result==null?false:result.length>0;
        }
        if(first=='*'){ 
          var reg = /\*/g;
          let vl= v.replace(reg,"");
          return value.toLowerCase().endsWith(vl.toLowerCase())?true:false;
        }
        if(end=='*'){
          var reg = /\*/g;
          let vl= v.replace(reg,"");
          return value.toLowerCase().startsWith(vl.toLowerCase())?true:false;
        }
      }
    }
    else if(v.indexOf("?") != -1)
    {
      if(v.charAt(0) == "?")
      {
        return value.indexOf(v.substr(1)) == 1;
      }
      else if(v.charAt(v.length-1) == "?")
      {
        return (value.indexOf(v.substring(0,v.length-1)) == 0 && value.length == v.length); 
      }
      else
      {
        if(value.length != v.length)
          return false;
        var s1 = v.substring(0,v.indexOf("?"));
        if(value.substring(0,v.indexOf("?")) != s1)
          return false;
        var s2 = v.substr(v.indexOf("?") + 1);
        if(value.substr(v.indexOf("?")+1) != s2)
          return false;
      }
    }
    else
    {
      return false;
    }
    
    return false;
  }

  static regFloat = /^(-?\d+)(\.\d+)?$/;
  static regInteger = /^-?\d+$/;
  static analysisLess(value,v)
  {
    var num2 = parseFloat(v);
    
    if(isNaN(num2) || RecordsUtil.regFloat.exec(v) == null || RecordsUtil.regInteger.exec(v) == null)
    {
      return value<v;
    }
    
    var num1 = parseFloat(value);
    if(isNaN(num1) || RecordsUtil.regFloat.exec(v) == null || RecordsUtil.regInteger.exec(v) == null)
    {
      return value<v;
    }
    
    return num1<num2;
  }
  
  static anaysisNQ(value,v)
  {
    return value != v;
  }
  
  static anaysisMore(value,v)
  {
    var num2 = parseFloat(v);
    if(isNaN(num2) || RecordsUtil.regFloat.exec(v) == null || RecordsUtil.regInteger.exec(v) == null)
    {
      return value>v;
    }
    
    var num1 = parseFloat(value);
    if(isNaN(num1) || RecordsUtil.regFloat.exec(v) == null || RecordsUtil.regInteger.exec(v) == null)
    {
      return value>v;
    }
    
    return num1>num2;
  }

}


// WEBPACK FOOTER //
// ./src/utils/RecordsUtil.js